<div class="comparison-header" mat-dialog-title>
  <div class="header-col recipient-header-col">
    <div class="header-participant">
      <mat-icon class="participant-icon">info</mat-icon>
      <div>
        <div class="participant-name">{{ data.recipient?.firstName }} {{ data.recipient?.lastName }}</div>
        <div class="participant-type">Recipient {{ data.recipient?.enisNumber }}</div>
      </div>
    </div>
  </div>
  <div class="header-col donor-header-col">
    <div class="header-participant">
      <mat-icon class="participant-icon">info</mat-icon>
      <div>
        <div class="participant-name">{{ data.donor?.firstName }} {{ data.donor?.lastName }}</div>
        <div class="participant-type">Donor {{ data.donor?.enisNumber }}</div>
      </div>
    </div>
  </div>
  <button mat-icon-button class="close-btn" (click)="close()" matTooltip="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="comparison-content">
  <div class="field-grid">

    <!-- Altruist (donor only) -->
    <div class="field recipient-field empty-field" *ngIf="data.donor?.altruist"></div>
    <div class="field donor-field" *ngIf="data.donor?.altruist">
      <span class="field-label">Altruist</span>
      <p>Yes</p>
    </div>

    <!-- Center -->
    <div class="field recipient-field">
      <span class="field-label">Center</span>
      <p>{{ data.recipient?.center?.name }}</p>
    </div>
    <div class="field donor-field">
      <span class="field-label">Center</span>
      <p>{{ data.donor?.center?.name }}</p>
    </div>

    <!-- Date of birth -->
    <div class="field recipient-field">
      <span class="field-label">Date of birth</span>
      <p>{{ formatDate(data.recipient?.dob) }} <span class="age">({{ recipientAge }} years old)</span></p>
    </div>
    <div class="field donor-field">
      <span class="field-label">Date of birth</span>
      <p>{{ formatDate(data.donor?.dob) }} <span class="age">({{ donorAge }} years old)</span></p>
    </div>

    <!-- ALIGNED: Blood group -->
    <div class="field recipient-field aligned-field">
      <span class="field-label">Blood group{{ data.recipient?.urgency ? ' / Ki-Urgency' : '' }}</span>
      <p>{{ data.recipient?.abo }}{{ data.recipient?.urgency ? ' / ' + data.recipient?.urgency : '' }}</p>
    </div>
    <div class="field donor-field aligned-field">
      <span class="field-label">Blood group</span>
      <p>{{ data.donor?.abo }}</p>
    </div>

    <!-- ALIGNED: HLA Class I -->
    <div class="field recipient-field aligned-field" *ngIf="showHla">
      <span class="field-label">HLA Class I</span>
      <p>{{ data.recipient?.abPhenotype }}</p>
    </div>
    <div class="field donor-field aligned-field" *ngIf="showHla">
      <span class="field-label">HLA Class I</span>
      <p>{{ donorHlaClassI }}</p>
    </div>

    <!-- ALIGNED: HLA Class II -->
    <div class="field recipient-field aligned-field" *ngIf="showHla">
      <span class="field-label">HLA Class II</span>
      <p>{{ data.recipient?.drPhenotype }}</p>
    </div>
    <div class="field donor-field aligned-field" *ngIf="showHla">
      <span class="field-label">HLA Class II</span>
      <p>{{ donorHlaClassII }}</p>
    </div>

    <!-- Unacceptables (recipient only) -->
    <div class="field recipient-field" *ngIf="data.recipient?.unacceptables">
      <span class="field-label">Unacceptables</span>
      <p>{{ data.recipient?.unacceptables }}</p>
    </div>
    <div class="field donor-field empty-field" *ngIf="data.recipient?.unacceptables"></div>

    <!-- Current vPRA (recipient only) -->
    <div class="field recipient-field" *ngIf="data.recipient?.virtualPRA !== null && data.recipient?.virtualPRA !== undefined">
      <span class="field-label">Current vPRA</span>
      <p>{{ data.recipient?.virtualPRA }}%</p>
    </div>
    <div class="field donor-field empty-field" *ngIf="data.recipient?.virtualPRA !== null && data.recipient?.virtualPRA !== undefined"></div>

    <!-- Date first dialysis (recipient only) -->
    <div class="field recipient-field" *ngIf="data.recipient?.dateFirstDialysis">
      <span class="field-label">Date first dialysis</span>
      <p>{{ formatDate(data.recipient?.dateFirstDialysis) }}</p>
    </div>
    <div class="field donor-field empty-field" *ngIf="data.recipient?.dateFirstDialysis"></div>

    <!-- Limited to Centers (donor only) -->
    <div class="field recipient-field empty-field" *ngIf="data.donor?.limitedToCenter?.length"></div>
    <div class="field donor-field" *ngIf="data.donor?.limitedToCenter?.length">
      <span class="field-label">Limited to Centers</span>
      <p>{{ donorLimitedToCenters }}</p>
    </div>

    <!-- Donate to Waitlist (donor only) -->
    <div class="field recipient-field empty-field" *ngIf="data.donor?.donateToWaitlist"></div>
    <div class="field donor-field" *ngIf="data.donor?.donateToWaitlist">
      <span class="field-label">Donate to Waitlist Only</span>
      <p>Yes</p>
    </div>

    <!-- Last updated -->
    <div class="field recipient-field" *ngIf="data.recipient?.lastUpdate">
      <span class="field-label">Last updated</span>
      <p>{{ formatDate(data.recipient?.lastUpdate) }}</p>
    </div>
    <div class="field donor-field" *ngIf="data.donor?.lastUpdate">
      <span class="field-label">Last updated</span>
      <p>{{ formatDate(data.donor?.lastUpdate) }}</p>
    </div>

  </div>
</mat-dialog-content>
